// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { ItemsPublishingSubscriptions } from '../../../../types/server/modules/itemsPublishing/subscriptions';

export type * from '../../../../types/server/modules/itemsPublishing/subscriptions';

export const createSubscriptions = ( requests: Requests ): ItemsPublishingSubscriptions => ({
  ItemsPublishingInventorySpreadsheet: ( params, onChange ) => {
          return requests.subscribe( `/items-publishing/inventory-spreadsheet`, params, 'ItemsPublishingInventorySpreadsheet', onChange );
          },
  ItemsPublishingInventory: ( params, onChange ) => {
          return requests.subscribe( `/items-publishing/inventory/:id?`, params, 'ItemsPublishingInventory', onChange );
          },
  ItemsPublishingPublications: ( params, onChange ) => {
          return requests.subscribe( `/items-publishing/publications/:id?`, params, 'ItemsPublishingPublications', onChange );
          },
  ItemsPublishingPublicationsBulkEditResults: ( params, onChange ) => {
          return requests.subscribe( `/items-publishing/publications-bulk-edit-results/:batchProcessId?`, params, 'ItemsPublishingPublicationsBulkEditResults', onChange );
          },
  ItemsPublishingPublicationDriftEpisodes: ( params, onChange ) => {
          return requests.subscribe( `/items-publishing/publication-drift-episodes/:id?`, params, 'ItemsPublishingPublicationDriftEpisodes', onChange );
          },
  ItemsPublishingPriceLists: ( params, onChange ) => {
          return requests.subscribe( `/items-publishing/price-lists/:id?`, params, 'ItemsPublishingPriceLists', onChange );
          },
  ItemsPublishingSizeGuides: ( params, onChange ) => {
          return requests.subscribe( `/items-publishing/size-guides/:id?`, params, 'ItemsPublishingSizeGuides', onChange );
          },
  ItemsPublishingAccountConfigurationReadmodel: ( params, onChange ) => {
          return requests.subscribe( `/items-publishing/account-configuration-readmodel/:id?`, params, 'ItemsPublishingAccountConfigurationReadmodel', onChange );
          },
  ItemsPublishingUserPreferencesReadmodel: ( params, onChange ) => {
          return requests.subscribe( `/items-publishing/user-preferences-readmodel/:id?`, params, 'ItemsPublishingUserPreferencesReadmodel', onChange );
          }
});
